export default function getApiUrl() {
  const API_PROTOCOL = process.env.REACT_APP_API_PROTOCOL || 'http'
  const API_HOST = process.env.REACT_APP_API_HOST || 'localhost'
  const API_PORT = process.env.REACT_APP_API_PORT || 3000
  const API_PREFIX = process.env.REACT_APP_API_PREFIX ? '/' + process.env.REACT_APP_API_PREFIX : ''
  return `${API_PROTOCOL}://${API_HOST}:${API_PORT}${API_PREFIX}`
}
